/** 404 — branded, helpful, with suggested destinations. */
import { Link } from "react-router-dom";
import { Home, BookOpen, Flame, Compass } from "lucide-react";
import {
  Container,
  Section,
  Eyebrow,
  DisplayHeading,
  Lede,
  AccentItalic,
  Button,
} from "../components/ui";

const SUGGESTIONS = [
  { to: "/", Icon: Home, label: "Homepage" },
  { to: "/courses", Icon: BookOpen, label: "Courses" },
  { to: "/sadhana", Icon: Flame, label: "Sadhana" },
  { to: "/services", Icon: Compass, label: "Services" },
];

export function NotFoundPage() {
  return (
    <Section padded="sm" data-testid="not-found-page">
      <Container>
        <div className="max-w-[720px] mx-auto text-center pt-10">
          <div className="inline-block font-display text-[clamp(80px,16vw,180px)] leading-none tracking-[-0.04em] text-mauve/30">
            404
          </div>
          <Eyebrow centered className="mt-2">
            Page not found
          </Eyebrow>
          <DisplayHeading className="mt-5">
            The path you sought
            <br />
            is <AccentItalic>elsewhere</AccentItalic>.
          </DisplayHeading>
          <Lede className="mt-6 mx-auto">
            The page you requested does not exist on this campus. Perhaps it has moved, or the
            link is out of date. Here are a few good places to continue.
          </Lede>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-[640px] mx-auto">
            {SUGGESTIONS.map(({ to, Icon, label }) => (
              <Link
                key={to}
                to={to}
                data-testid={`404-suggestion-${label.toLowerCase()}`}
                className="group flex flex-col items-center gap-2 px-4 py-5 rounded-[18px] border border-line-2 bg-surface hover:border-mauve hover:bg-surface-2 transition-all hover:-translate-y-[1px]"
              >
                <Icon size={20} className="text-mauve" />
                <span className="text-[13px] font-medium">{label}</span>
              </Link>
            ))}
          </div>
          <div className="mt-10">
            <Button asChild>
              <Link to="/">Return home</Link>
            </Button>
          </div>
        </div>
      </Container>
    </Section>
  );
}
